import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const FIELDS = [
  { key: "tagline_fr", label: "Slogan (FR)", type: "text" },
  { key: "tagline_en", label: "Slogan (EN)", type: "text" },
  { key: "email_paris", label: "Email — Paris", type: "text" },
  { key: "email_ny", label: "Email — New York", type: "text" },
  { key: "phone_paris", label: "Téléphone — Paris", type: "text" },
  { key: "phone_ny", label: "Téléphone — New York", type: "text" },
  { key: "address_paris", label: "Adresse — Paris", type: "textarea" },
  { key: "address_ny", label: "Adresse — New York", type: "textarea" },
  { key: "instagram", label: "Instagram (URL)", type: "text" },
  { key: "pinterest", label: "Pinterest (URL)", type: "text" },
];

export default function ContactSettings({ onSitePublicRefresh }) {
  const [form, setForm] = useState({});
  const [initial, setInitial] = useState({});
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const r = await api.get("/settings");
      setForm(r.data || {});
      setInitial(r.data || {});
    } catch { /* ignore */ }
  };
  useEffect(() => { load(); }, []);

  const dirty = JSON.stringify(form) !== JSON.stringify(initial);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", form);
      toast.success("Enregistré");
      setInitial(form);
      if (onSitePublicRefresh) onSitePublicRefresh();
    } catch {
      toast.error("Échec");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-serif text-3xl text-[#0A1128]">Contact & pied de page</h2>
          <p className="text-sm text-[#0A1128]/60 mt-1">Coordonnées, adresses et réseaux sociaux visibles sur le site public.</p>
        </div>
        {dirty && (
          <button onClick={save} disabled={saving} className="bg-[#0A1128] text-[#F9F8F6] px-6 py-2.5 text-xs tracking-[0.24em] uppercase flex items-center gap-2 disabled:opacity-60" data-testid="settings-save">
            <Save size={14} /> {saving ? "..." : "Enregistrer"}
          </button>
        )}
      </div>
      <div className="bg-white border border-[#0A1128]/10 p-6 grid md:grid-cols-2 gap-5" data-testid="settings-form">
        {FIELDS.map((f) => (
          <div key={f.key} className={f.type === "textarea" ? "md:col-span-2" : ""}>
            <label className="overline text-[#0A1128]/60">{f.label}</label>
            {f.type === "textarea" ? (
              <textarea rows={2} value={form[f.key] || ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} className="w-full border border-[#0A1128]/15 px-3 py-2 text-sm resize-none mt-1" data-testid={`settings-${f.key}`} />
            ) : (
              <input value={form[f.key] || ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} className="w-full border-b border-[#0A1128]/20 py-2 focus:outline-none focus:border-[#D4AF37] mt-1" data-testid={`settings-${f.key}`} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
